import { cn } from '@/lib/cn'

/**
 * The assistant's mark: a glassy orb filled with the Apple Intelligence gradient.
 * It rotates while `active`, and rests otherwise.
 */
export function AiOrb({ className, active = true }: { className?: string; active?: boolean }) {
  return (
    <span aria-hidden className={cn('ai-orb inline-block size-4 shrink-0', !active && 'ai-orb-static', className)} />
  )
}
